import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  Alert,
  Paper
} from '@mui/material';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:6001/api';

// Add a fallback mechanism
const getApiUrl = async () => {
  try {
    const response = await fetch('http://localhost:6001/api/health');
    if (response.ok) {
      return 'http://localhost:6001/api';
    }
  } catch (error) {
    console.log('Primary port unavailable, trying alternative...');
  }
  return 'http://localhost:6000/api'; // fallback
};

function TestRateLimit() {
  const { token } = useAuth();
  const [count, setCount] = useState(1);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const simulateGenerations = async () => {
    try {
      const response = await axios.post(
        `${API_URL}/generate/test-limit`,
        { count: parseInt(count) },
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      setResult(response.data);
      setError(null);
      
      // Dispatch event to notify that generations have been added
      const event = new Event('imageGenerated');
      window.dispatchEvent(event);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to simulate generations');
    }
  };

  const resetCounter = async () => {
    try {
      const response = await axios.post(
        `${API_URL}/generate/reset-counter`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );
      setResult(response.data);
      setError(null);
      
      // Dispatch event to notify that counter has been reset
      const event = new Event('imageGenerated');
      window.dispatchEvent(event);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to reset counter');
    }
  };

  return (
    <Paper sx={{ p: 3, mt: 3 }}>
      <Typography variant="h6" gutterBottom>
        Test Rate Limit
      </Typography>
      
      <Box sx={{ mb: 2 }}>
        <TextField
          type="number"
          label="Number of generations"
          value={count}
          onChange={(e) => setCount(e.target.value)}
          sx={{ mr: 2 }}
        />
        <Button 
          variant="contained" 
          onClick={simulateGenerations}
          sx={{ mr: 1 }}
        >
          Simulate
        </Button>
        <Button 
          variant="outlined" 
          onClick={resetCounter}
        >
          Reset Counter
        </Button>
      </Box>

      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      {result && (
        <Box>
          <Typography variant="body1">
            {result.message}
          </Typography>
          <Typography variant="body2">
            Total Generated: {result.totalGenerated} / {result.limit}
          </Typography>
          <Typography variant="body2">
            Remaining: {result.remaining}
          </Typography>
          <Typography variant="body2">
            Can Generate More: {result.canStillGenerate ? 'Yes' : 'No'}
          </Typography>
          <Typography variant="body2">
            Next Reset: {new Date(result.nextReset).toLocaleDateString()}
          </Typography>
        </Box>
      )}
    </Paper>
  );
}

export default TestRateLimit; 